import {reportError} from 'app/client/models/AppModel';
import {DiscordAllowlistModelImpl} from 'app/client/models/DiscordAllowlistModel';
import {OrgConfigsAPI} from 'app/client/ui/ConfigsAPI';
import {DiscordAllowlistConfig} from 'app/client/ui/DiscordAllowlistConfig';
import {basicButton} from 'app/client/ui2018/buttons';
import {theme} from 'app/client/ui2018/cssVars';
import {cssModalTitle, modal} from 'app/client/ui2018/modals';
import {dom, styled} from 'grainjs';
import {makeT} from 'app/client/lib/localization';

const t = makeT('DiscordTeamAllowlistDialog');

/**
 * Open a modal that lets a team owner manage the per-team Discord allowlist.
 * Each entry is a Discord user id; on the next Discord sign-in any user whose
 * id is in the list is auto-added as an editor of this team.
 */
export function openDiscordTeamAllowlistDialog(org: {id: number; name?: string; domain?: string | null}) {
  return modal((ctl, owner) => {
    const configsAPI = new OrgConfigsAPI(org.id);
    const model = DiscordAllowlistModelImpl.create(owner, {configsAPI});
    model.fetch().catch(reportError);
    return [
      cssAllowlistModal.cls(''),
      cssModalTitle(t("Discord allowlist for {{team}}", {team: org.name || org.domain || `#${org.id}`})),
      cssAllowlistBody(
        dom.create(DiscordAllowlistConfig, model),
      ),
      cssAllowlistFooter(
        basicButton(t("Close"), dom.on('click', () => ctl.close())),
      ),
    ];
  });
}

const cssAllowlistModal = styled('div', `
  max-width: 600px;
  width: 90vw;
`);

const cssAllowlistBody = styled('div', `
  padding: 8px 0;
  max-height: 60vh;
  overflow-y: auto;
`);

const cssAllowlistFooter = styled('div', `
  display: flex;
  justify-content: flex-end;
  padding-top: 12px;
  border-top: 1px solid ${theme.modalBorder};
`);
